// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__27CZs","contained":"OpenButton_contained__1FkVg","disabled":"OpenButton_disabled__2wdvo","error":"OpenButton_error__3maas"};